import { useUser } from "@/queries/user"
import { useViewedCallback } from "@/analytics/react"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import { router } from "expo-router"
import { View } from "react-native"
import type { UserType } from "@/generated/graphql"
import { RewardsHeader } from "@/screens/rewards/old/RewardsHeader"
import { RewardsContent } from "@/screens/rewards/old/RewardsContent"

export default function Rewards() {
  const { data: user } = useUser()

  useViewedCallback(() => {
    setStatusBarStyle("light")
  })

  const onDismiss = () => {
    router.push("../")
  }

  return (
    <View className="flex flex-col flex-1 overflow-hidden bg-calm-blue">
      <RewardsHeader
        balance={
          (user?.me?.lastPointTransaction
            ? user.me.lastPointTransaction.balance
            : 0) + ""
        }
        pointsValue={
          "$" +
          (user?.me?.lastPointTransaction
            ? user.me.lastPointTransaction.balance / 10
            : 0)
        }
        availableReferrals={user?.me?.availableReferrals + ""}
        spent={
          (user?.me?.lastPointTransaction
            ? user.me.lastPointTransaction.spent
            : 0) + ""
        }
        onDismiss={onDismiss}
      />
      <RewardsContent user={user?.me as UserType} />
    </View>
  )
}
